import { render, staticRenderFns } from "./page-list.vue?vue&type=template&id=ba9303aa&scoped=true"
import script from "./page-list.vue?vue&type=script&lang=js"
export * from "./page-list.vue?vue&type=script&lang=js"
import style0 from "./page-list.vue?vue&type=style&index=0&id=ba9303aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9303aa",
  null
  
)

export default component.exports